module.exports = __webpack_public_path__ + "media/CN_011.48ffb7df.mp3";